export enum FileUploadTypes {
  ONBOARDING = "onboarding",
  DATA = "data",
  CHAT = "chat",
}

export const ALLOWED_FILE_TYPES = [
  "PDF",
  "XLSX",
  "JPG",
  "JPEG",
  "PNG",
  "GIF",
  "WEBP",
  "BMP",
  "DOCX",
];
